import React from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import style from './index.css';

import TxtTitle from '../../../../../components/txtTitle';
import List from './list';

class ProductEvaluation extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        const config = {
            title: content.title,
            link: content.link,
        };

        return (
            <div className={style.wrap}>
                <TxtTitle content={config} />

                <List content={content.data} />
            </div>
        );
    }
}

export default ProductEvaluation;
